module.exports = __webpack_public_path__ + "images/emoji/full_moon_with_face.62e2f55668c6539b4881.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/full_moon_with_face.png
// module id = R56P
// module chunks = 1